<template>
  <div id="app">
      <router-view></router-view>
      <Footer/>

      <!-- 全局可拖动客服气泡 -->
      <div
        class="chatwoot-custom-launcher"
        :style="{ right: bubblePos.right + 'px', bottom: bubblePos.bottom + 'px' }"
        @touchstart="dragStart"
        @touchmove="dragMove"
        @touchend="dragEnd"
        @click="toggleChatwoot"
      >
        <!-- 这里的标题气泡 -->
        <div class="launcher-title" v-if="showTitle">
          何かお手传いしましょうか？
        </div>

        <div class="launcher-inner">
          <svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" style="width: 40px; height: 40px; fill: white;">
            <path d="M19 6C19 2.686 15.866 0 12 0C8.134 0 5 2.686 5 6C5 7.654 5.765 9.125 7 10.198V13.5C7 13.776 7.224 14 7.5 14C7.595 14 7.688 13.973 7.768 13.922L10.518 12.182C11.002 12.26 11.496 12.3 12 12.3C15.866 12.3 19 9.614 19 6.3V6Z" />
          </svg>
        </div>
      </div>
  </div>
</template>

<script>
import Footer from './common/Footer'
export default {
  name: 'app',
  components: {
    Footer
  },
  data() {
    return {
      status:0,
      showTitle: true,
      bubblePos: {
        right: 20,
        bottom: 200
      },
      isDragging: false,
      startTouchPos: { x: 0, y: 0 },
      moveThreshold: 5
    };
  },
  methods: {
    getBaseInfo(){
      this.$http({
        method: 'get',
        url: 'base_info'
      }).then(res=>{
        if(!localStorage.getItem('token')){
           this.$router.push({path:'/Login'})
        }
        this.$store.commit('setBaseInfoValue', res.data);
      })
    },
    initChatwoot() {
      window.chatwootSettings = {
        "position":"right",
        "type":"standard",
        "launcherTitle":"何かお手伝いしましょうか？",
        "hideMessageBubble": true
      };

      (function(d,t) {
        var BASE_URL="https://app.chatwoot.com";
        var g=d.createElement(t),s=d.getElementsByTagName(t)[0];
        g.src=BASE_URL+"/packs/js/sdk.js";
        g.async = true;
        s.parentNode.insertBefore(g,s);
        g.onload=function(){
          window.chatwootSDK.run({
            websiteToken: 'JSkVCfg9ScyET3F1azdXjmSU',
            baseUrl: BASE_URL
          })
        }
      })(document,"script");
    },
    dragStart(e) {
      const touch = e.touches[0];
      this.startTouchPos.x = touch.clientX;
      this.startTouchPos.y = touch.clientY;
      this.isDragging = false;
    },
    dragMove(e) {
      const touch = e.touches[0];
      const deltaX = touch.clientX - this.startTouchPos.x;
      const deltaY = touch.clientY - this.startTouchPos.y;

      if (Math.abs(deltaX) > this.moveThreshold || Math.abs(deltaY) > this.moveThreshold) {
        this.isDragging = true;
        this.showTitle = false; // 拖动时隐藏标题，松开后也不再显示
      }

      if (this.isDragging) {
        this.bubblePos.right -= deltaX;
        this.bubblePos.bottom -= deltaY;

        const screenWidth = window.innerWidth;
        const screenHeight = window.innerHeight;
        if (this.bubblePos.right < 0) this.bubblePos.right = 0;
        if (this.bubblePos.right > screenWidth - 80) this.bubblePos.right = screenWidth - 80;
        if (this.bubblePos.bottom < 50) this.bubblePos.bottom = 50;
        if (this.bubblePos.bottom > screenHeight - 100) this.bubblePos.bottom = screenHeight - 100;

        this.startTouchPos.x = touch.clientX;
        this.startTouchPos.y = touch.clientY;
        e.preventDefault();
      }
    },
    dragEnd() {},
    toggleChatwoot() {
      if (!this.isDragging && window.$chatwoot) {
        window.$chatwoot.toggle();
        this.showTitle = false; // 点击后隐藏标题
      }
    }
  },
  mounted() {
    this.initChatwoot();
  },
  created(){
    this.getBaseInfo();
  }
}
</script>

<style>
body .van-toast {
  font-size: 38px;
  padding: 30px;
  line-height: 50px;
  width: 230px;
  background: linear-gradient(30deg, #7d76ef, #d63f8c) !important;
}
body .van-toast .van-toast__icon {
  font-size: 50px;
}
*, :after, :before {
  box-sizing: border-box;
}

.chatwoot-custom-launcher {
  position: fixed;
  width: 100px;
  height: 100px;
  z-index: 99999;
  touch-action: none;
  display: flex;
  align-items: center;
  justify-content: center;
}

.launcher-inner {
  width: 100%;
  height: 100%;
  background: linear-gradient(135deg, #d63f8c, #7d76ef);
  border-radius: 50%;
  box-shadow: 0 8px 24px rgba(214, 63, 140, 0.3);
  display: flex;
  align-items: center;
  justify-content: center;
}

/* 自定义标题气泡样式 */
.launcher-title {
  position: absolute;
  right: 120px; /* 位于大球左侧 */
  background: white;
  color: #333;
  padding: 15px 25px;
  border-radius: 15px;
  box-shadow: 0 4px 15px rgba(0,0,0,0.1);
  font-size: 24px;
  white-space: nowrap;
  pointer-events: none; /* 点击穿透到下方 */
}

/* 气泡尖角 */
.launcher-title::after {
  content: '';
  position: absolute;
  right: -15px;
  top: 50%;
  transform: translateY(-50%);
  border-left: 15px solid white;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
}
</style>